import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { getFaqs, getFaqCategories } from '../../../services/faqService';

const BADGE_COLORS = {
  가입: '#10B981',
  정산: '#F59E0B',
  DB: '#3B82F6',
  파트너: '#8B5CF6',
};

const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const Chip = styled.button`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;
  background: ${({ $active, theme }) => $active ? theme.colors.primary : '#fff'};
  color: ${({ $active }) => $active ? '#fff' : '#1F2937'};
  border: ${({ $active, theme }) => $active ? 'none' : `1px solid ${theme.colors.border}`};
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const Item = styled.div`
  background: #fff;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  overflow: hidden;
`;

const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.base};
  cursor: pointer;
`;

const ItemLeft = styled.div`
  flex: 1;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ $color }) => $color};
  background: ${({ $color }) => `${$color}18`};
  margin-bottom: 8px;
`;

const Question = styled.p`
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 4px;
`;

const DateText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: #9CA3AF;
  font-family: 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif;
  font-weight: 500;
  letter-spacing: -0.2px;
`;

const Answer = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.base} ${({ theme }) => theme.spacing.base};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.6;
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  padding-top: ${({ theme }) => theme.spacing.base};
`;

const EmptyText = styled.p`
  text-align: center;
  padding: 60px 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const RealtorFaq = () => {
  const [activeCategory, setActiveCategory] = useState('전체');
  const [openIdx, setOpenIdx] = useState(0);
  const [categories, setCategories] = useState(['전체']);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFaqCategories().then(setCategories).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    getFaqs(activeCategory)
      .then(setFaqs)
      .catch(() => setFaqs([]))
      .finally(() => setLoading(false));
  }, [activeCategory]);

  return (
    <Container>
      <ChipRow>
        {categories.map((c) => (
          <Chip key={c} $active={activeCategory === c} onClick={() => { setActiveCategory(c); setOpenIdx(-1); }}>
            {c}
          </Chip>
        ))}
      </ChipRow>

      {loading ? (
        <EmptyText>로딩 중...</EmptyText>
      ) : faqs.length === 0 ? (
        <EmptyText>FAQ가 없습니다.</EmptyText>
      ) : (
        <List>
          {faqs.map((item, i) => (
          <Item key={i}>
            <ItemHeader onClick={() => setOpenIdx(openIdx === i ? -1 : i)}>
              <ItemLeft>
                <Badge $color={BADGE_COLORS[item.category]}>{item.category}</Badge>
                <Question>{item.question}</Question>
                <DateText>최종 수정일: {item.date}</DateText>
              </ItemLeft>
              {openIdx === i ? (
                <IoChevronUp size={20} color="#9CA3AF" />
              ) : (
                <IoChevronDown size={20} color="#9CA3AF" />
              )}
            </ItemHeader>
            {openIdx === i && item.answer && (
              <Answer>{item.answer}</Answer>
            )}
          </Item>
          ))}
        </List>
      )}
    </Container>
  );
};

export default RealtorFaq;
